module.exports = __webpack_public_path__ + "img/frame-camera-img.e0eebcb9.svg";